/**
 * Base URL of the api server. Next inlines `NEXT_PUBLIC_API_URL` at build via
 * source-level substitution; falls back to localhost:4000 in dev/non-browser.
 * Single source of truth for the tRPC clients and the auth-fetch wrapper.
 */
export const API_URL =
  typeof process !== 'undefined'
    ? (process.env['NEXT_PUBLIC_API_URL'] ?? 'http://localhost:4000')
    : 'http://localhost:4000';
